import React  from 'react';
import './DetailsBanner.css';
import banner from './banner.jpg'


const DetailsBanner = (props) => {

    // console.log("Details Banner:", props.league);
    const { strLogo, strBadge } = props.league;
    
    return (
        <div>
            {/* Banner Start */}
            <div className="banner" style={{position: 'relative'}}>
                <img src={strLogo} style={{position: 'absolute', width: '20%', top: '35%', left: '40%'}} className=""/>
                <img src={banner} alt="" style={{width: '100%', height: '70%'}}/>
            </div>
            {/* Banner End */}
        </div>
    );
};

export default DetailsBanner;